import ApiUrl from 'enum/api-url.enum';
import httpService from 'services/http/http.service';

function postNotificationMark(data) {
  return httpService.post(ApiUrl.MARK_NOTIFICATION_READ, data);
}

const obj = { postNotificationMark };

export default obj;
